import { render, staticRenderFns } from "./Produktreiter.vue?vue&type=template&id=aad8baa0&"
import script from "./Produktreiter.vue?vue&type=script&lang=js&"
export * from "./Produktreiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports